import '@picsart/design-system/foundation.css';

import { Preloader } from '@/components/ui/Preloader';
import useOpen from '@/hooks/useOpen';
import { getContext, isContextAvailable } from '@/miniappContext';
import analytics, { buildSettings, ScreenActionType } from '@/utils/analytics';
import { closeMiniapp } from '@/utils/closeMiniapp';
import { isStandalone } from '@/utils/isStandAlone';

import { AIWardrobe } from './AIWardrobe';
import { ErrorBoundary } from './ErrorBoundary';

import useStyles from './styles';

function App() {
  const sdkOpen = useOpen();
  const isReady = sdkOpen || isStandalone();

  const isInEditor = isContextAvailable() && (getContext().general.location.getState().route?.includes('/create/editor') ?? false);
  const isNativeMobile = isContextAvailable() && (getContext().handlers.isIOS() || getContext().handlers.isAndroid());
  const showClose = isInEditor || isNativeMobile;

  useStyles();

  const handleClose = async () => {
    analytics.screenAction({ action: ScreenActionType.CLOSE, settings: buildSettings() });
    await closeMiniapp();
  };

  if (!isReady) return <Preloader />;

  return (
    <ErrorBoundary>
      <AIWardrobe onClose={showClose ? handleClose : undefined} />
    </ErrorBoundary>
  );
}

export default App;
